<app-layout>
  <header>
    <h2><i class="pi pi-folder-open"></i> Carpeta MIP</h2>

    <form
      [formGroup]="reportsForm"
      novalidate
      (submit)="onSubmit($event)"
      class="form"
    >
      <figcaption class="form-figcaption">
        Debes filtrar los resultados por fecha
      </figcaption>

      <div class="form-group">
        <p-calendar
          formControlName="initialDate"
          [iconDisplay]="'input'"
          [showIcon]="true"
          inputId="icondisplay"
          placeholder="Fecha de inicio"
        />

        <p-calendar
          formControlName="finalDate"
          [iconDisplay]="'input'"
          [showIcon]="true"
          inputId="icondisplay"
          placeholder="Fecha de final"
        />
      </div>

      <div class="form-group">
        <!-- <div class="checkbox-group">
          <p-checkbox
            formControlName="OR"
            value="OR"
            inputId="or"
          />

          <label for="or">Orden de servicio</label>
        </div> -->

        <div class="checkbox-group">
          <p-checkbox formControlName="CT" value="CT" inputId="ct" />

          <label for="ct">Certificado</label>
        </div>

        <div class="checkbox-group">
          <p-checkbox formControlName="RP" value="RP" inputId="rp" />

          <label for="rp">Reporte</label>
        </div>

        <div class="checkbox-group">
          <p-checkbox formControlName="RM" value="RM" inputId="rm" />

          <label for="rm">Remisión</label>
        </div>

        <div class="checkbox-group">
          <p-checkbox formControlName="QO" value="QO" inputId="qo" />

          <label for="qo">Cotización</label>
        </div>
      </div>

      <p-button
        type="submit"
        class="button"
        label="Descargar carpeta MIP"
        icon="pi pi-file-pdf"
      >
        <!-- <i class="pi pi-file-pdf"></i> Descargar carpeta MIP -->
      </p-button>
    </form>
  </header>
</app-layout>
